/**
 * A widget for display of a nominator/denominator, title, tooltip, and slider.
 * The nominator and denominator values are expected to be numeric values.  The widget will display
 * these a currency values (formatted to USD), and will calculate a slider value.
 */
import React, { Component } from 'react';
import { Grid, LinearProgress, Paper, Tooltip, Typography} from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import HelpOutline from '@mui/icons-material/HelpOutline';

const styleSheet = theme => ({
  root: {
    width: '100%',
  },
  dbTile: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 212
  },
  dbTile2: {
    [theme.breakpoints.up('xs')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(1),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(2),
    },
    height: 68,
    width: 184
  },
  lp1: {
    height: 12,
    width: 204
  },
  lp2: {
    height: 12,
    width: 176
  },
});
  
class LinearProgressWidget extends Component {
    
  constructor(props) {
    super(props);
  }

  render() {
    const classes = this.props.classes;

    const { narrow, nominator, denominator, description, descriptionStart, descriptionEnd, tooltip } = this.props;

    let theTileClass = classes.dbTile;
    let theLpClass   = classes.lp1;
    if (narrow === true) {
      theTileClass = classes.dbTile2;
      theLpClass   = classes.lp2;
    }

    let theNominator   = Number(nominator);
    let theDenominator = Number(denominator);
    let percentUsed    = 0;
    let dividedValue   = 0;
    if (theDenominator > 0) {
      dividedValue = theNominator / theDenominator;
    }

    dividedValue = dividedValue * 100;
    percentUsed = Math.round(dividedValue);

    let theDescription = '';
    if (description != null) {
      theDescription = description;
    } else {
      if (descriptionStart != null) {
        theDescription = descriptionStart;
      }

      theDescription = theDescription + percentUsed;

      if (descriptionEnd != null) {
        theDescription = theDescription + descriptionEnd;
      }
    }

    let nominatorDisplay = Number(theNominator).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
    let denominatorDisplay = Number(theDenominator).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});

    return (
      <Paper className={theTileClass}>
        <Grid container spacing={1} direction="column" justifyContent="flex-start" alignItems="center">
          <Grid item style={{marginBottom: '-3px'}}>
            <Typography variant="h6">{nominatorDisplay} / <sub>{denominatorDisplay}</sub></Typography>
          </Grid>
          <Grid item>
            <Grid container justifyContent="flex-start" alignItems="center" spacing={0}>
              <Grid>
                <Typography variant="body2" align="center">{theDescription}</Typography>
              </Grid>
              <Grid item>
                <Tooltip placement='bottom' title={tooltip}>
                  <HelpOutline fontSize="small" style={{verticalAlign: "-9%", marginLeft: '4px'}}/>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
          <Grid>
            <LinearProgress variant="buffer" value={percentUsed} className={theLpClass}
                            valueBuffer={100} color="secondary" />
          </Grid>
        </Grid>
      </Paper>
    );
  }
}

export default withStyles(styleSheet)(LinearProgressWidget);

